import {INVE_FIELDS} from '@/constants/inve';
import {DocumentData} from '@/engine';
import {InvestorAccount} from '@/types/client-info';
import {mapAccountFabToDomainValue} from '@/utils/client-info/mappers/map-account-fab';
import {mapAccountPurchaserMemberContractholderToDomainValue} from '@/utils/client-info/mappers/map-account-purchaser-member-contractholder';
import {mapAccountSpousalFlagToDomainValue} from '@/utils/client-info/mappers/map-account-spousal-flag';
import {mapAccountTypeToDomainValue} from '@/utils/client-info/mappers/map-account-type';
import {mapGuaranteeToDomainValue} from '@/utils/client-info/mappers/map-guarantee';
import {mapProductTypeToDomainValue} from '@/utils/client-info/mappers/map-product-type';

export const mapExistingContractsToINVE = (accounts: InvestorAccount[]): DocumentData['data'] => {
  const mappedAccounts: DocumentData['data'] = {};

  mappedAccounts[INVE_FIELDS.INVE42_existingAccountsCount] = accounts.length.toString();

  accounts.forEach((account, index) => {
    mappedAccounts[`${INVE_FIELDS.INVE43_existingAccountNo}#${index}`] = account.accountNo.toString();

    const productType = mapProductTypeToDomainValue(account.productType);
    if (productType) mappedAccounts[`${INVE_FIELDS.INVE44_existingAccountProductType}#${index}`] = productType;

    const plan = mapAccountTypeToDomainValue(account.plan);
    if (plan) mappedAccounts[`${INVE_FIELDS.INVE45_existingAccountPlan}#${index}`] = plan;

    const guaranty = mapGuaranteeToDomainValue(account.guaranty);
    if (guaranty) mappedAccounts[`${INVE_FIELDS.INVE46_existingAccountGuarantee}#${index}`] = guaranty;

    const spousalFlag = mapAccountSpousalFlagToDomainValue(account.spousalFlag);
    if (spousalFlag) mappedAccounts[`${INVE_FIELDS.INVE40_existingAccountSpousalFlag}#${index}`] = spousalFlag;

    const fab = mapAccountFabToDomainValue(account.fab);
    if (fab) mappedAccounts[`${INVE_FIELDS.INVE41_existingAccountFab}#${index}`] = fab;

    const purchaserMemberContractHolder = mapAccountPurchaserMemberContractholderToDomainValue(
      account.purchaserMemberContractHolder,
    );
    if (purchaserMemberContractHolder) {
      mappedAccounts[`${INVE_FIELDS.INVE47_existingAccountPurchaserMemberContractHolder}#${index}`] =
        purchaserMemberContractHolder;
    }
  });

  return mappedAccounts;
};
